"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMsgAction = exports.defaultMsgsAction = exports.attachDenom = exports.formatLogs = void 0;
var decodeBase64 = function (str) {
    try {
        return Buffer.from(str, "base64").toString();
    }
    catch (_a) {
        return str;
    }
};
var BASE64_REGEX = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$/;
var isBase64 = function (value) { return BASE64_REGEX.test(value); };
var isBase64Extended = function (value) {
    // we are only interested in json-alike base64's, which generally start with "ey" ('{')
    return value.startsWith("ey") &&
        // other checks
        isBase64(value);
};
var reviver = function (_, value) {
    return typeof value === "string" && isBase64Extended(value)
        ? JSON.parse(decodeBase64(value), reviver)
        : value;
};
var decodeExecuteMsg = function (str) {
    if (typeof str === "string" && isBase64Extended(str)) {
        var decoded = decodeBase64(str);
        try {
            return JSON.stringify(JSON.parse(decoded, reviver), null, 2);
        }
        catch (_a) {
            return decoded;
        }
    }
    return JSON.stringify(str, undefined, 2);
};
var formatLogs = function (data, msgType, address, timestamp, txhash) {
    if (data.transformed) {
        var transformed = data.transformed;
        var type = transformed.type, withdraw_date = transformed.withdraw_date;
        var logData = __assign(__assign({}, data), { timestamp: timestamp, txhash: txhash });
        if (type === "delegate" && msgType === "MsgDelegate") {
            return __assign(__assign({}, logData), { transformed: __assign(__assign({}, transformed), { sender: address }) });
        }
        else if (type === "unDelegate" &&
            msgType === "MsgUndelegate" &&
            withdraw_date) {
            var now = new Date();
            var withdrawDate = new Date(withdraw_date);
            return __assign(__assign({}, logData), { transformed: __assign(__assign({}, transformed), { recipient: now > withdrawDate ? address : "" }) });
        }
    }
    return __assign(__assign({}, data), { timestamp: timestamp, txhash: txhash });
};
exports.formatLogs = formatLogs;
var attachDenom = function (string) {
    return string.includes("uluna") ? "" + string : string + "uluna";
};
exports.attachDenom = attachDenom;
var defaultMsgsAction = function (tx) {
    var msgs = tx.tx.value.msg;
    var action = [];
    msgs.forEach(function (msg) {
        action.push(exports.defaultMsgAction(msg));
    });
    return action;
};
exports.defaultMsgsAction = defaultMsgsAction;
var defaultMsgAction = function (msg) {
    var fragment = {
        type: "Unknown",
        attributes: [],
    };
    var result = {
        fragment: fragment,
        match: [],
    };
    if (msg.type === "wasm/MsgExecuteContract") {
        var contract = msg.value.contract;
        var executeMsg = msg.value.execute_msg;
        // successful wasm decode
        try {
            var decodeMsg = JSON.parse(decodeExecuteMsg(executeMsg));
            var key = Object.keys(decodeMsg)[0];
            var transformed = {
                msgType: "wasm/execute",
                canonicalMsg: ["Execute " + (key || "default") + " on " + contract],
                payload: fragment,
            };
            return __assign(__assign({}, result), { transformed: transformed });
        }
        catch (e) {
            // comes here, then it's unknown
            return __assign(__assign({}, result), { transformed: {
                    msgType: "wasm/execute",
                    canonicalMsg: ["Execute default on " + contract],
                    payload: fragment,
                } });
        }
    }
    else {
        var msgTypes = msg.type.split("/");
        var transformed = {
            msgType: "terra/" + (msgTypes[0] || "terra"),
            canonicalMsg: [msgTypes[1] || "Unknown tx"],
            payload: fragment,
        };
        return __assign(__assign({}, result), { transformed: transformed });
    }
};
exports.defaultMsgAction = defaultMsgAction;
//# sourceMappingURL=utility.js.map